var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"twitter","d":"M11.515,28.043A15.724,15.724,0,0,0,27.341,12.217c0-.239,0-.477-.011-.716a11.331,11.331,0,0,0,2.778-2.888,11.273,11.273,0,0,1-3.2.88A5.6,5.6,0,0,0,29.36,6.412a11.065,11.065,0,0,1-3.538,1.346,5.562,5.562,0,0,0-9.62,3.807,6.145,6.145,0,0,0,.141,1.269A15.8,15.8,0,0,1,4.877,7.019,5.578,5.578,0,0,0,6.6,14.449a5.626,5.626,0,0,1-2.517-.694v.076a5.575,5.575,0,0,0,4.459,5.457,5.423,5.423,0,0,1-1.464.2,5.488,5.488,0,0,1-1.044-.1,5.563,5.563,0,0,0,5.2,3.863,11.156,11.156,0,0,1-6.91,2.385A10.7,10.7,0,0,1,3,25.558a15.823,15.823,0,0,0,8.516,2.484","transform":"translate(-3 -6)"}));
}

Twitter.defaultProps = {"width":"27.108","height":"22.043","viewBox":"0 0 27.108 22.043"};

module.exports = Twitter;

Twitter.default = Twitter;
